<template>
  <div :style="{ backgroundColor }" class="search absolute top-0 left-0 bg-white h-full w-full px-4 z-20">
    <input :style="{ backgroundColor }" ref="search" v-model="searchTerm" @keyup.esc="close" autocomplete="off" class="py-2 h-full w-full outline-none px-6" type="text" :placeholder="$t('search', 'search')" tabindex="0">
    <ul :style="{ backgroundColor }" v-if="searching" class="absolute bg-white border border-current left--1 right--1">
      <li class="mx-4 my-4 pulse" v-if="searching">{{ $t('search', 'busy') }}</li>
    </ul>
    <ul :style="{ backgroundColor }" @click="close" v-else-if="searchResults" class="results absolute bg-white border border-current left--1 right--1">
      <li class="mx-4 my-4" v-for="(result, count) in localeList(searchResults)" :key="count">
        <router-link :to="localeLink('/' + processUri(result.uri))">
          {{ result.title }} <span v-if="result.date" class="uppercase inline-block px-2">({{ formatDate(result.date) }})</span>
          <span class="uppercase text-xs serif pl-1 song">{{ types(result) }}</span>
        </router-link>
      </li>
      <li class="mx-4 my-4" v-if="searchResults.length == 0">{{ $t('search', 'noResults') }}</li>
    </ul>
    <div class="flex h-full absolute top-0 right-0 items-center mx-6 cursor-pointer" @click="close">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1.3306" y1="1.09957" x2="27.1254" y2="26.8944" stroke="currentColor"/>
      <line x1="27.1255" y1="1.80668" x2="1.33074" y2="27.6015" stroke="currentColor"/>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'SearchBar',
  data () {
    return {
      searching: false
    }
  },
  props: ['show'],
  computed: {
    searchTerm: {
      get () {
        return this.$store.state.searchTerm
      },
      set (value) {
        this.$store.commit('SET_SEARCH_TERM', value)
      }
    },
    backgroundColor () {
      return this.$store.state.style.backgroundColor
    },

    ...mapState(['lang', 'searchResults'])
  },
  methods: {
    close () {
      this.searching = false
      this.searchTerm = null
      this.$store.commit('SET_SEARCH_RESULTS', null)
      this.$emit('hide')
    },
    types (item) {
      if (item.types !== '' && !item.types.isArray && item.types.length) {
        if (item.types === 'Entity') {
          return this.$t('types', 'entity')
        } else if (item.types === 'News') {
          return this.$t('types', 'news')
        } else if (item.types === 'Contribution') {
          return this.$t('types', 'contribution')
        } else if (item.types === 'Program') {
          return this.$t('types', 'program')
        } else {
          return ''
        }
      } else if (item.types.length > 0) {
        return item.types.map(t => t.title).join(', ')
      }
    },
    processUri (uri) {
      uri = uri.replace('news-section', 'news')
      return uri
    },
    ...mapActions(['search'])
  },
  watch: {
    searchTerm () {
      if (this.searchTerm && this.searchTerm !== '') {
        this.searching = true
        this.debouncedSearch()
      } else {
        this.searching = false
        this.$store.commit('SET_SEARCH_RESULTS', null)
      }
    },
    searchResults () {
      if (this.searchResults) {
        this.searching = false
      }
    },
    show () {
      if (this.show) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    }
  },
  created () {
    this.debouncedSearch = debounce(this.search, 500)
  },
  mounted () {
    this.$refs.search && this.$refs.search.focus()
  }
}
</script>

<style lang="stylus" scoped>
  .results
    max-height 60vh
    overflow-y auto

    a:hover, a.router-link-active
      color red
</style>
